import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { CHANGE_PASSWORD_AUTH_MODE, AUTH_MODES, AUTH_MODES_ROUTES } from '../../modules/auth/auth.constants';
import { ChangePassword } from './changePassword';
import { Container, Content } from './auth.styles';

const componentsMap = {
  [CHANGE_PASSWORD_AUTH_MODE]: ChangePassword,
};

export const Auth = ({ initAuthMode, clearAuthMode }) => {
  useEffect(() => {
    initAuthMode();

    return clearAuthMode;
    //eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Content>
        <Switch>
          {AUTH_MODES.map(mode => (
            <Route key={mode} path={AUTH_MODES_ROUTES[mode]} component={componentsMap[mode]} />
          ))}
        </Switch>
      </Content>
    </Container>
  );
};

Auth.propTypes = {
  initAuthMode: PropTypes.func.isRequired,
  clearAuthMode: PropTypes.func.isRequired,
};
